import moment from 'moment';

export const CSS_UID = 'field-birth-date-24qsdfssfg4-00f8-4e7b-8825-456qsdf465qs';

/**
 * calculate age
 * @param {*} valueAge
 * @param {string} methodCalculateAge
 */
export const calculateAge = (date, methodCalculateAge) => {
  try {
    let dateEnd;

    switch (methodCalculateAge) {
      case 'startYear':
        dateEnd = moment(`${moment().year()}-01-01`);
        break;
      case 'startContract':
        // TODO
        dateEnd = moment();
        break;
      case 'birthdate':
      default:
        dateEnd = moment();
        break;
    }

    const age = dateEnd.diff(date, 'years');

    if (age < 0) {
      return 0;
    }

    return age;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`calculateAge: ${e.stack}`);
  }
  return 0;
};
